import { useInfiniteQuery } from 'react-query';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { useViewerStore } from '@store/viewerModule/base';
import { getViewerSessions, getLiveSessions } from '@src/api/viewerModule';
import { VM_LIVE_REFRESH_INTERVAL } from '@utils/constants';
import { featureSelector } from '@store/common/selectors';
import vmSelector from '@store/viewerModule/selectors';
import { getMetricsFromList } from '@store/viewerModule/base/helpers';
import { buildSessionRequestBody } from '../common/utils';

function useFetchData() {
  const [{ viewerId, filterId, interval }] = useViewerStore();
  const selectedColumns = useSelector(vmSelector).base.selectedColumns;
  const { startDate, endDate, days, isLive } = interval;
  const paramList = [viewerId, filterId, startDate, endDate, days, isLive, selectedColumns];
  const isTLBLiveEnabled = useSelector(featureSelector('vm-live-tlb'));

  const columns = getMetricsFromList(selectedColumns);
  const data = {
    viewerId,
    columns,
    interval,
    isLive,
    page: 0,
    limit: moment(endDate).diff(moment(startDate), 'days') > 20 ? 500 : 200,
  };

  let viewerApiFn: any = () => null;
  let queryBody: any = {};
  const refetchInterval = isLive ? VM_LIVE_REFRESH_INTERVAL : false;

  if (isLive && !isTLBLiveEnabled) {
    viewerApiFn = getLiveSessions;
    queryBody = { viewerId, filterId, isLive };
  } else {
    queryBody = buildSessionRequestBody(data);
    viewerApiFn = getViewerSessions;
  }

  const getPageScroll = useInfiniteQuery(
    ['getViewerSessions', ...paramList],
    ({ pageParam = 0 }) => {
      queryBody.page = pageParam;
      return viewerApiFn({
        params: { page: pageParam },
        body: queryBody,
      });
    },
    {
      enabled: !!viewerId,
      retry: false,
      refetchOnWindowFocus: false,
      refetchInterval,
      getNextPageParam: (lastPage, pages) => {
        const records: any[] = get(lastPage, ['data', 'data'], []);
        return records.length > 0 ? pages.length : undefined;
      },
    },
  );

  const forLive = useInfiniteQuery(
    ['getViewerSessions', ...paramList],
    ({ pageParam = 0 }) => {
      return viewerApiFn({
        params: { page: pageParam },
        body: queryBody,
      });
    },
    {
      enabled: !!viewerId,
      retry: false,
      refetchOnWindowFocus: false,
      refetchInterval,
    },
  );
  if (isLive) {
    return forLive;
  }
  return getPageScroll;
}

export default useFetchData;
